import React, { useState, useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import AppContext from '../../AppContext';
import { routes } from '../../routes';
import {
  CenteredWidthAndHeightLayout,
  CenteredBoxSmall,
  SpacingBox,
  PrimaryButton,
  RedParagraph,
} from '../../Components';

import { getUserId, getUserById } from '../../selectors';
import CustomerDropdownWithSearch from './CustomerDropdownWithSearch';
import { getTranslateByScope } from '../../i18n';
import SeasonsDropdown from './SeasonsDropdown';

const translate = getTranslateByScope('app.selectCustomer');

const OrderCreation = withRouter(({ history }) => {
  const [customer, selectCustomer] = useState();
  const [season, selectSeason] = useState();
  const [errorMessage, setErrorMessage] = useState([]);
  const { actions } = useContext(AppContext);

  const onCreate = (id) => {
    history.push(routes.orderUpdate(id), {
      routeOnSubmit: routes.landingPage,
    });
  };

  const context = useContext(AppContext);
  const userId = getUserId(context);
  const user = getUserById(context, userId);

  const handleCreate = () => {
    let message = [];
    if (!season) {
      message = [...message, translate('errorMessages.missingSeason')];
    }

    let c = customer;
    if (context.state.lowa) {
      c = context.state.lowaCustomer;
      c.id = c.Id; // hack
    }

    if (c === null || c === undefined) {
      message = [...message, translate('errorMessages.missingCustomer')];
    }


    if (!c || !season) {
      setErrorMessage(message);
      return;
    }

    actions.createOrderForCustomer({
      user, customer: c, season, onCreate,
    });
  };

  return (
    <>
      <CenteredWidthAndHeightLayout>
        <CenteredBoxSmall>
          <SpacingBox>
            <SeasonsDropdown selectSeason={selectSeason} />
            <CustomerDropdownWithSearch selectCustomer={selectCustomer} />
            {_.uniq(errorMessage).map((e) => (
              <RedParagraph>{e}</RedParagraph>
            ))}
            <SpacingBox marginTop="lg">
              <PrimaryButton
                onClick={handleCreate}
                text={translate('select.createOrder')}
              />
            </SpacingBox>
          </SpacingBox>
        </CenteredBoxSmall>
      </CenteredWidthAndHeightLayout>
    </>
  );
});

export default OrderCreation;
